import axios from 'axios'
import API from '@/API.js'

const apiClient = axios.create({
  baseURL: `${API}/clientes/etiquetas`,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    Authorization: localStorage.getItem('argusblack.token')
  }
})

// Actualización del token de autorización
document.addEventListener('actualizar:token', function(e) {
  apiClient.defaults.headers['Authorization'] = e.detail
})

// Eliminación del token de autorización
document.addEventListener('eliminar:token', function() {
  apiClient.defaults.headers['Authorization'] = null
})

export default {
  actualizar(etiqueta) {
    return apiClient.post(`${etiqueta.id}`, etiqueta)
  },

  eliminar(idEtiqueta) {
    return apiClient.delete(`${idEtiqueta}`)
  },

  guardar(etiqueta) {
    return apiClient.post('', etiqueta)
  },

  etiquetaJSON(idEtiqueta) {
    return apiClient.get(`${idEtiqueta}.json`)
  },

  etiquetasJSON(params) {
    params = params || {}
    return apiClient.get(`${API}/clientes/etiquetas.json`, { params: params })
  }
}
